import { render, staticRenderFns } from "./vr-settings.vue?vue&type=template&id=724f7e66&scoped=true&lang=html"
import script from "./vr-settings.vue?vue&type=script&lang=js"
export * from "./vr-settings.vue?vue&type=script&lang=js"
import style0 from "./vr-settings.vue?vue&type=style&index=0&id=724f7e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f7e66",
  null
  
)

export default component.exports